import queryString from "query-string";
import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks";
import { httpClient } from "@/lib/http";
import {
  GetJobWithPartialCandidacyCountsByStatusResponse,
  HttpResponse,
  JobStatus,
} from "@/types";

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
type GetJobsWithPartialCandidacyCountsByStatusOptions = {
  jobStatuses?: JobStatus[];
};

export function useGetJobsWithPartialCandidacyCountsByStatus(
  options?: GetJobsWithPartialCandidacyCountsByStatusOptions,
) {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    queryKey: [
      "jobs/with_partial_counts_by_status",
      currentCompanyId,
      options?.jobStatuses,
    ],
    queryFn: async () => {
      const query = queryString.stringify(
        { jobStatus: options?.jobStatuses },
        { arrayFormat: "bracket" },
      );
      const path = `companies/${currentCompanyId}/jobs/with_partial_counts_by_status?${query}`;
      const res = await httpClient.get<
        GetJobWithPartialCandidacyCountsByStatusResponse[],
        HttpResponse<GetJobWithPartialCandidacyCountsByStatusResponse[]>
      >(path);
      return res.data;
    },
  });
}
